import * as React from "react";
import { styled } from "@mui/material";
import { KahunColorMap } from "fe-common/ui/assets/colorMap";

export const AgentFooterHeight = 0; // todo: 26;
const FooterView = styled("div")({
  width: "100%",
  position: "fixed",
  bottom: 0,
  left: 0,
  backgroundColor: KahunColorMap.White,
  height: `${AgentFooterHeight || 48}px`,
  zIndex: 1,
  padding: "16px 8px 14px 8px",
  fontSize: "14px",
  lineHeight: "19px",
  color: KahunColorMap.Default,
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
});

export const Footer = ({ ...props }) => (
  <FooterView {...props}>©Kahun Medical 2023</FooterView>
);
